export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-[#F5E6D3]">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#4A7C59] text-center mb-8 md:mb-12 px-4" style={{ fontFamily: 'Pacifico, cursive' }}>
          Contact & Accès
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
          {/* Map */}
          <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl h-80 md:h-96 lg:h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3717.3222857714286!2d55.489305576851436!3d-21.298277982374696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2182a1300c9d5ef3%3A0x55fe0f821d62e9aa!2sLe%20Bokal%20Givr%C3%A9!5e0!3m2!1sfr!2sfr!4v1764224436101!5m2!1sfr!2sfr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localisation Le Bokal Givré"
            ></iframe>
          </div>

          {/* Contact Info */}
          <div className="space-y-6 md:space-y-8">
            {/* Address */}
            <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#4A7C59] rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold text-[#4A7C59] mb-2">Adresse</h3>
                  <p className="text-gray-700 text-sm md:text-base">
                    52 Chemin Edward Savigny<br />
                    Ligne des Bambous<br />
                    97432 Saint-Pierre<br />
                    La Réunion
                  </p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#FF8F6B] rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-white text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold text-[#4A7C59] mb-2">Téléphone</h3>
                  <a href="tel:+262693527676" className="text-gray-700 hover:text-[#FF8F6B] transition-colors text-base md:text-lg cursor-pointer">
                    +262 693 52 76 76
                  </a>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#4A7C59] rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-white text-lg md:text-xl"></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-[#4A7C59] mb-2">Email</h3>
                  <a href="mailto:lebokalgivre.cie@gmail.com" className="text-gray-700 hover:text-[#FF8F6B] transition-colors cursor-pointer text-sm md:text-base break-words">
                    lebokalgivre.cie@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* Horaires */}
            <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#FF8F6B] rounded-full flex-shrink-0">
                  <i className="ri-time-line text-white text-lg md:text-xl"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-[#4A7C59] mb-3 md:mb-4">Horaires</h3>
                  
                  {/* Brunch */}
                  <div className="mb-4 pb-4 border-b border-gray-200">
                    <p className="font-bold text-[#4A7C59] mb-2 text-sm md:text-base">🥞 Brunch</p>
                    <div className="space-y-1 text-gray-700 text-sm md:text-base">
                      <div className="flex justify-between gap-2">
                        <span className="font-semibold">Lundi</span>
                        <span className="whitespace-nowrap">11h-14h</span>
                      </div>
                      <div className="flex justify-between gap-2">
                        <span className="font-semibold">Samedi & Dimanche</span>
                        <span className="whitespace-nowrap">10h-12h / 13h-15h</span>
                      </div>
                    </div>
                  </div>

                  {/* Bar & Tapas */}
                  <div>
                    <p className="font-bold text-[#4A7C59] mb-2 text-sm md:text-base">🍹 Bar & Tapas (Soir)</p>
                    <div className="space-y-1 text-gray-700 text-sm md:text-base">
                      <div className="flex justify-between gap-2">
                        <span className="font-semibold">Jeudi, Dimanche, Lundi</span>
                        <span className="whitespace-nowrap">17h30-22h</span>
                      </div>
                      <div className="flex justify-between gap-2">
                        <span className="font-semibold">Vendredi & Samedi</span>
                        <span className="whitespace-nowrap">17h30-23h</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Social */}
            <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#4A7C59] rounded-full flex-shrink-0">
                  <i className="ri-share-line text-white text-lg md:text-xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg md:text-xl font-bold text-[#4A7C59] mb-3 md:mb-4">Réseaux Sociaux</h3>
                  <div className="flex flex-wrap gap-3 md:gap-4">
                    <a
                      href="https://www.instagram.com/lebokalgivre/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-3 md:px-4 py-2 bg-[#4A7C59] text-white rounded-full hover:bg-[#3d6849] transition-all cursor-pointer whitespace-nowrap text-sm md:text-base"
                    >
                      <i className="ri-instagram-line"></i>
                      @lebokalgivre
                    </a>
                    <a
                      href="https://www.facebook.com/100063594639194"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-3 md:px-4 py-2 bg-[#FF8F6B] text-white rounded-full hover:bg-[#ff7a52] transition-all cursor-pointer whitespace-nowrap text-sm md:text-base"
                    >
                      <i className="ri-facebook-fill"></i>
                      Facebook
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
